import { api } from "./api";

export interface WeakTopic {
    subject: string;
    topic: string;
    avg_score: number;
    attempts: number;
    days_since_last: number;
}

export interface ReviewTopic {
    subject: string;
    topic: string;
    avg_score: number;
    attempts: number;
    days_since_last: number;
}

export interface Recommendations {
    weakTopics: WeakTopic[];
    reviewTopics: ReviewTopic[];
    inactiveSubjects: string[];
}

export interface ImprovedTopic {
    subject: string;
    topic: string;
    early_avg: number;
    recent_avg: number;
    improvement: number;
}

export interface SubjectStat {
    subject: string;
    total_quizzes: number;
    avg_score: number;
    best_score: number;
    worst_score: number;
    total_correct: number;
    total_questions: number;
}

export interface ProgressPoint {
    date: string;
    avg_score: number;
    quiz_count: number;
}

export interface Achievement {
    subject: string;
    topic: string;
    score: number;
    date_taken: string;
}

export interface Insights {
    progressTrend: ProgressPoint[];
    improvedTopics: ImprovedTopic[];
    subjectStats: SubjectStat[];
    recentAchievements: Achievement[];
}

export const adaptiveLearningService = {
    getRecommendations: async (): Promise<Recommendations> => {
        try {
            return await api.get('/learning/recommendations');
        } catch (error) {
            console.error('Failed to fetch recommendations:', error);
            return { weakTopics: [], reviewTopics: [], inactiveSubjects: [] };
        }
    },

    getInsights: async (): Promise<Insights> => {
        try {
            return await api.get('/learning/insights');
        } catch (error) {
            console.error('Failed to fetch insights:', error);
            return {
                progressTrend: [],
                improvedTopics: [],
                subjectStats: [],
                recentAchievements: []
            };
        }
    }
};
